import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global-styles.css';
import clone from '@/utils/clone.js';

// Vue.prototype.$echarts = echarts
const Plugins = [clone];
Plugins.map((plugin) => {
  Vue.use(plugin);
});

Vue.use(ElementUI, {
  size: 'small'
});

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
